import { Avatar, CircularProgress, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@material-ui/core';
import { Delete, MoreVert as MoreVertIcon } from '@material-ui/icons';
import * as React from 'react';
import { connect } from 'react-redux';

import { Permissions } from 'shared/models/permission';
import { hasRole } from 'shared/models/user';

import { deleteProfileLink } from '../actions';
import { RequestErrors, State } from '../state';

const avatarSize = 18;
const iconSizeRatio = 0.75;
const colorRed600 = '#e53935';

interface OwnProps {
    url: string;
    personId: string;
}

interface ConnectedProps {
    pendingRequests: Map<string, RequestErrors>;
    userPermissions: Permissions;
}

interface ConnectedDispatch {
    deleteProfileLink: (personId: string, url: string) => void;
}

type ProfileLinkAttributesProps = OwnProps & ConnectedProps & ConnectedDispatch;

export const ProfileLinkAttributesComponent: React.FC<ProfileLinkAttributesProps> = (props) => {
    const { url, pendingRequests, personId, userPermissions } = props;

    const updateRequestKey = `website-update-request-${url}`;
    const disabled = pendingRequests.has(updateRequestKey) && pendingRequests.get(updateRequestKey).isEmpty();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleLinkDelete = () => {
        if (!disabled) {
            props.deleteProfileLink(personId, url);
            setAnchorEl(null);
        }
    };

    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
        if (!disabled) {
            setAnchorEl(event.currentTarget);
        }
    };

    const handleCloseMenu = () => setAnchorEl(null);

    if (hasRole(userPermissions, 'profile_links_editor')) {
        let content: JSX.Element;
        if (disabled) {
            const spinnerSize = 20;
            const spinnerThickness = 2;
            content = <CircularProgress size={spinnerSize} thickness={spinnerThickness} />;
        } else {
            const removeIcon = (
                <Avatar
                    style={{ width: avatarSize, height: avatarSize, backgroundColor: colorRed600 }}
                    className="avatar-contact-attribute"
                >
                    <Delete style={{ color: '#fff', fontSize: avatarSize * iconSizeRatio }} />
                </Avatar>
            );

            const button = (
                <IconButton disableRipple={true} style={{ width: 16, height: 16, padding: 0 }} onClick={handleOpenMenu}>
                    <MoreVertIcon className="icon-button-more" style={{ height: 16, width: 16 }} />
                </IconButton>
            );

            content = (
                <div className="contact-attributes">
                    <div className="list-item-menu-button">
                        {button}
                        <Menu
                            anchorEl={anchorEl}
                            keepMounted={true}
                            open={Boolean(anchorEl)}
                            onClose={handleCloseMenu}
                            anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                        >
                            <MenuItem
                                onClick={handleLinkDelete}
                                disabled={!hasRole(userPermissions, 'profile_links_editor')}
                            >
                                <ListItemIcon style={{ minWidth: 32 }}>{removeIcon}</ListItemIcon>
                                <ListItemText primary="Delete" />
                            </MenuItem>
                        </Menu>
                    </div>
                </div>
            );
        }

        return content;
    } else {
        return null;
    }
};

const mapStateToProps = (state: State): any => ({
    pendingRequests: state.pendingRequests,
    userPermissions: state.session.userPermissions
});

const mapStateToDispatch = {
    deleteProfileLink
};

export const ProfileLinkAttributes = connect<ConnectedProps, ConnectedDispatch, OwnProps>(
    mapStateToProps,
    mapStateToDispatch
)(ProfileLinkAttributesComponent);
